import { AxiosError } from 'axios'
import { trackingAxios } from 'config/api/tracking'
import { CriteriaFile } from '../domain/CriteriaFile'
import { ICriteriaFileRepository } from '../domain/repositories/ICriteriaFileRepository'

const DEFAULT_ERROR_MESSAGE =
    'No se pudo descargar el archivo del criterio. Intenta nuevamente.'
const NOT_FOUND_MESSAGE =
    'El archivo del criterio no está disponible para descargar.'

const getFileNameFromDisposition = (
    contentDisposition: string | undefined,
    fallback: string
): string => {
    if (contentDisposition === undefined || contentDisposition === '') {
        return fallback
    }
    const match = contentDisposition.match(
        /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
    )
    return match !== null ? decodeURIComponent(match[1]) : fallback
}

const parseMessage = (message?: string): string => {
    return message !== undefined && message !== '' ? message : DEFAULT_ERROR_MESSAGE
}

const extractErrorMessage = async (
    error: AxiosError<Blob | { message?: string }>
): Promise<string> => {
    if (error.response?.status === 404) {
        return NOT_FOUND_MESSAGE
    }

    const data = error.response?.data

    if (data instanceof Blob) {
        try {
            const parsed = JSON.parse(await data.text()) as { message?: string }
            return parseMessage(parsed.message)
        } catch {
            return DEFAULT_ERROR_MESSAGE
        }
    }

    return parseMessage(data?.message)
}

export class AxiosCriteriaFileRepository implements ICriteriaFileRepository {
    async download(
        groupId: number,
        criteriaId: number
    ): Promise<CriteriaFile> {
        try {
            const response = await trackingAxios.get(
                `groups/${groupId}/criteria/${criteriaId}/download`,
                {
                    responseType: 'blob',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                }
            )

            return {
                blob: new Blob([response.data]),
                filename: getFileNameFromDisposition(
                    response.headers['content-disposition'],
                    `criteria-${criteriaId}.xlsx`
                ),
            }
        } catch (error) {
            throw new Error(
                await extractErrorMessage(
                    error as AxiosError<Blob | { message?: string }>
                )
            )
        }
    }
}
